import(/* webpackMode: "eager" */ "/vercel/path0/app/resources/case-studies/education-procurement/page.tsx");
